import type { ProductsTypeV3 } from 'domains/products/products.types';

export enum MobilePaymentStateEnum {
  DEFAULT,
  CARD,
}

export enum MobilePaymentStatusEnum {
  DEFAULT,
  LOADING,
  SUCCESS,
  FAIL,
}

export interface IMobilePaymentInitialState {
  isVisible: boolean;
  isLoadingCard: boolean;
  isLoadingButton: boolean;
  isProcessing: boolean;
  product?: ProductsTypeV3;
  coupon?: string;
  modalType: 'Auth' | 'Registration';
  state: MobilePaymentStateEnum;
  walletCardId: string | null;
  paymentType?: string; // 'card' | 'applepay' | 'googlepay'
  status: MobilePaymentStatusEnum;
}
